import { TOKEN_TERM } from '../../../constants';
import { Token } from '../../../Values/Token';

/**
 * User term token.
 *
 */
export class User extends Token {
  constructor(
    lexeme: string,
    position: number,
    public marker: string,
    public user: string,
  ) {
    super(TOKEN_TERM, lexeme, position);
  }
}
